import { render } from "./attendance-comprehensive-report.vue?vue&type=template&id=188d16b0&scoped=true"
import script from "./attendance-comprehensive-report.vue?vue&type=script&lang=js"
export * from "./attendance-comprehensive-report.vue?vue&type=script&lang=js"

import "./attendance-comprehensive-report.vue?vue&type=style&index=0&id=188d16b0&scoped=true&lang=css"
import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-188d16b0"]])

export default __exports__